module.exports = __webpack_public_path__ + "static/media/medal-empty.0676886e.png";